module.exports = __webpack_public_path__ + "static/img/img3.b29fe2f4.png";